import { profilePath } from "@travily/routes";
import type MemberSearchHit from "@travily/types/pending/models/MemberSearchHit";
import { AccountAvatar } from "@/components/AccountAvatar/AccountAvatar";
import { MapPinCard } from "@/components/MapPinCard/MapPinCard";

export interface MemberMapPinCardProps {
  hit: MemberSearchHit;
  onClose: () => void;
}

export function MemberMapPinCard({ hit, onClose }: MemberMapPinCardProps) {
  return (
    <MapPinCard
      description={hit.location_label}
      href={profilePath(hit.handle)}
      image={hit.avatar}
      imageFallback={
        <AccountAvatar
          account={{ profile_type: hit.type, initial: hit.initial }}
          className="size-full rounded-none text-6xl"
        />
      }
      linkLabel={hit.display_name}
      onClose={onClose}
      title={hit.display_name}
    />
  );
}
